export interface MaskConfiguration {
  mask: (string | RegExp)[];
  unmask: (val: string) => string;
}

const unMaskUnderscores = (val: string) => {
  return val.replace(/[_]/g, '');
};

const unMaskUnderscoresAndSpaces = (val: string) => {
  return val.replace(/[_| ]/g, '');
};

function repeatPattern(
  val: string | RegExp,
  times: number,
): (string | RegExp)[] {
  const array = Array(times);
  for (let i = 0; i < times; i++) {
    array[i] = val;
  }

  return array;
}

const AnyChar = /[0-9A-Z]/;

export namespace MaskConstants {
  export const NumeroSSConfig: MaskConfiguration = {
    mask: [
      /[1-2]/,
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 3),
      ' ',
      ...repeatPattern(/\d/, 3),
      ' ',
      ...repeatPattern(/\d/, 2),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };
  export const NumeroOrgaAffiliationConfig: MaskConfiguration = {
    mask: [
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 3),
      ' ',
      ...repeatPattern(/\d/, 3),
      ' ',
      ...repeatPattern(/\d/, 1),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export const SiretConfig: MaskConfiguration = {
    mask: [...repeatPattern(/\d/, 14)],
    unmask: unMaskUnderscores,
  };

  export const WzPolicyConfig: MaskConfiguration = {
    mask: [...repeatPattern(/[A-Za-z]/, 3), ' ', ...repeatPattern(AnyChar, 10)],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export const SirenConfig: MaskConfiguration = {
    mask: [...repeatPattern(/\d/, 9)],
    unmask: unMaskUnderscores,
  };

  export const AllPhoneConfig: MaskConfiguration = {
    mask: [
      '0',
      /[1-9]/,
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export const LocalPhoneConfig: MaskConfiguration = {
    mask: [
      '0',
      /[1-5|8-9]/,
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export const MobileConfig: MaskConfiguration = {
    mask: [
      '0',
      /[6-7]/,
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
      ' ',
      ...repeatPattern(/\d/, 2),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export const ChequeNumber: MaskConfiguration = {
    mask: [
      ...repeatPattern(/\d/, 1),
      ' ',
      ...repeatPattern(/\d/, 3),
      ' ',
      ...repeatPattern(/\d/, 3),
    ],
    unmask: unMaskUnderscoresAndSpaces,
  };

  export function IbanBuilder(
    prefix: string,
    pattern: number[],
  ): MaskConfiguration {
    let builder: (string | RegExp)[] = [
      new RegExp(prefix[0]),
      new RegExp(prefix[1]),
      AnyChar,
      AnyChar,
    ];

    builder = builder.concat(
      ...pattern.map((rep) => [' ', ...repeatPattern(AnyChar, rep)]),
    );
    return {
      mask: [...builder],
      unmask: unMaskUnderscoresAndSpaces,
    };
  }

  export const IbanATConfig = IbanBuilder('AT', [4, 4, 4, 4]);
  export const IbanBEConfig = IbanBuilder('BE', [4, 4, 4]);
  export const IbanDEConfig = IbanBuilder('DE', [4, 4, 4, 4, 2]);
  export const IbanEEConfig = IbanBuilder('EE', [4, 4, 4, 4]);
  export const IbanESConfig = IbanBuilder('ES', [4, 4, 4, 4, 4]);
  export const IbanFIConfig = IbanBuilder('FI', [4, 4, 4, 2]);
  export const IbanFRConfig = IbanBuilder('FR', [4, 4, 4, 4, 4, 3]);
  export const IbanGRConfig = IbanBuilder('GR', [4, 4, 4, 4, 4, 3]);
  export const IbanIEConfig = IbanBuilder('IE', [4, 4, 4, 4, 2]);
  export const IbanITConfig = IbanBuilder('IT', [4, 4, 4, 4, 4, 3]);
  export const IbanLTConfig = IbanBuilder('LT', [4, 4, 4, 4]);
  export const IbanLUConfig = IbanBuilder('LU', [4, 4, 4, 4]);
  export const IbanLVConfig = IbanBuilder('LV', [4, 4, 4, 4, 1]);
  export const IbanMTConfig = IbanBuilder('MT', [4, 4, 4, 4, 4, 4, 3]);
  export const IbanNLConfig = IbanBuilder('NL', [4, 4, 4, 2]);
  export const IbanPTConfig = IbanBuilder('PT', [4, 4, 4, 4, 4, 1]);
  export const IbanSIConfig = IbanBuilder('SI', [4, 4, 4, 3]);
  export const IbanSKConfig = IbanBuilder('SK', [4, 4, 4, 4, 4]);
  export const IbanCYConfig = IbanBuilder('CY', [4, 4, 4, 4, 4, 4]);

  export const DateConfig: MaskConfiguration = {
    // 00/00/0000
    mask: [
      ...repeatPattern(/[0-9]/, 2),
      '/',
      ...repeatPattern(/[0-9]/, 2),
      '/',
      ...repeatPattern(/[0-9]/, 4),
    ],
    unmask: unMaskUnderscores,
  };
}
